import { Button, Space } from '@pyt/micros'
import { useContext, useEffect, useState } from 'react'

import { FilterFooter } from '../../FilterModal'
import GCMContext from '../GCMContext'
import { getStayTypes } from '../utils/getCostingText'
import GroupButton from './GroupButton'

/**
 * Mobile component to get the room & pax related info
 * @param {String} headerText - Headet Text for the screen
 * @param {Function} onChange - callback method once they choosen the config
 * @param {Function} onLeftClick - action for header left button (back event)
 * @param {Function} onRightClick - action for header right button (close)
 */
const Duration = ({ showCustomOptionByDefault, onChange }) => {
	const [{ duration }] = useContext(GCMContext)

	// maintain pax count choosen in separate state
	const [durationOption, setDurationOption] = useState(null)
	// flag to show room config option - this is set to true if the paxType is not SOLO/COUPLE
	const [showCustomOption, setShowCustomOption] = useState(
		showCustomOptionByDefault || null,
	)
	// initial room config options - each object in array represent one room
	// default value is 1 room 2 adults
	const [durationOfStay, setDurationOfStay] = useState(duration)

	useEffect(() => {
		if (durationOption) {
			if (durationOption === 'custom') {
				setShowCustomOption(true)
			} else {
				setDurationOfStay(durationOption)
				typeof onChange === 'function' && onChange(durationOption)
			}
		}
	}, [durationOption, onChange])

	const onSubmit = () => {
		typeof onChange === 'function' && onChange(durationOfStay)
	}

	return (
		<Space
			gutter={0}
			direction="column"
			justifyContent={'space-between'}
			height={'100%'}
		>
			<div style={{ padding: '24px' }}>
				{showCustomOption ? (
					<div></div>
				) : (
					<GroupButton
						vertical
						callBackAction={setDurationOption}
						groupButtonText={getStayTypes()}
					/>
				)}
			</div>
			{showCustomOption ? (
				<FilterFooter backgroundColor={'#fff'} noShadow padding={'24px'}>
					<Button variant="primary" onPress={onSubmit}>
						{'Continue'}
					</Button>
				</FilterFooter>
			) : null}
		</Space>
	)
}

export default Duration
